export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			layout: 'Dubai',
			sidebar: {
				type: 'compact-wrapper',
			},
			sidebar_setting: 'default-sidebar',
		},
		color: {
			primary_color: '#FA6400',
			secondary_color: '#FAB12F',
			mix_background_layout: 'light-only',
		},
		router_animation: 'fadeIn'
	};
}
export default ConfigDB;
